export default {
  label: {
    computer: 'Computer',
    mobile: 'Cell Phone/Tablet',
    notClassified: 'Not Classified',
  },
};
